import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CookieWrapper } from '@services/cookie.service';
import { AppRoutes } from '@helpers/app-routes';
import { AuthCredentialsFormComponent } from '@components/auth-credentials-form/auth-credentials-form.component';
import { LoaderComponent } from '@components/app-loader/app-loader.component';
import { ModalClearCacheComponent } from '@components/Modals/modal-clear-cache/modal-clear-cache.component';

const HIDDEN_CLEAR_CACHE_TAP_COUNT = 5;
const HIDDEN_CLEAR_CACHE_TAP_WINDOW_MS = 1000;

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [
    RouterLink,
    TranslateModule,
    AuthCredentialsFormComponent,
    LoaderComponent,
    ModalClearCacheComponent,
  ],
  styleUrl: './login-page.component.scss',
  host: {
    class: 'flex-1 h-full block',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './login-page.component.html',
})
export class LoginPageComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly cookie = inject(CookieWrapper);

  readonly showClearCacheModal = signal(false);
  #titleTapCount = 0;
  #titleTapResetTimeout: ReturnType<typeof setTimeout> | null = null;

  ngOnInit(): void {
    if (this.cookie.check('caisse_token')) {
      void this.router.navigate([AppRoutes.scanPage]);
    }
  }

  ngOnDestroy(): void {
    if (this.#titleTapResetTimeout !== null) {
      clearTimeout(this.#titleTapResetTimeout);
    }
  }

  onLoginSuccess(): void {
    void this.router.navigate([AppRoutes.scanPage]);
  }

  onTitleTap(): void {
    this.#titleTapCount++;

    if (this.#titleTapResetTimeout !== null) {
      clearTimeout(this.#titleTapResetTimeout);
    }
    this.#titleTapResetTimeout = setTimeout(() => {
      this.#titleTapCount = 0;
    }, HIDDEN_CLEAR_CACHE_TAP_WINDOW_MS);

    if (this.#titleTapCount >= HIDDEN_CLEAR_CACHE_TAP_COUNT) {
      this.#titleTapCount = 0;
      this.showClearCacheModal.set(true);
    }
  }

  closeClearCacheModal(): void {
    this.showClearCacheModal.set(false);
  }

  confirmClearCache(): void {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = `/${AppRoutes.login}`;
  }
}
